import { Link, Loader } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { useTenant } from "@contexts/Tenant/Tenant.context";
import { MSPRO_SUPPORT_EMAIL } from "@core/core.constants";
import { useGetGroup } from "@services/apiEcms/useGetGroup";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { ErrorWithContactProps } from "./ErrorWithContact.types";

export const ErrorWithContact: FC<ErrorWithContactProps> = ({
  title,
  text,
  imageType = "errorFix",
}) => {
  const { t } = useCustomTranslation("common");
  const { freshdeskSupportUrl, supportEmail: defaultSupportEmail } =
    useTenant();
  const { currentGroup } = useGroupReferences();

  const defaultTitle = t("errors.title.large");
  const defaultText = t("errors.text");

  const { data: email, isLoading } = useGetGroup<string>({
    groupId: currentGroup,
    options: {
      select: (res) => res.group.email,
    },
  });
  const supportEmail = email || defaultSupportEmail;
  const hasDedicatedSupportEmail = supportEmail !== MSPRO_SUPPORT_EMAIL;

  if (isLoading) return <Loader />;

  return (
    <ErrorTemplate
      data-testid="ErrorWithContact-container"
      imageType={imageType}
      text={
        hasDedicatedSupportEmail
          ? text || defaultText
          : t("errors.withContact.description")
      }
      title={title || defaultTitle}
    >
      <Link
        href={
          hasDedicatedSupportEmail
            ? `mailto:${supportEmail}`
            : freshdeskSupportUrl
        }
      >
        {hasDedicatedSupportEmail ? supportEmail : t("errors.withContact.form")}
      </Link>
    </ErrorTemplate>
  );
};
